import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import CardContent from '@mui/material/CardContent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useAuth } from '../../../../../sections/auth/AuthContext'
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import IconButton from 'components/@extended/IconButton';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import avatar1 from 'assets/images/users/admin.png';
import { useNavigate } from 'react-router';

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`profile-tabpanel-${index}`} aria-labelledby={`profile-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`
  };
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

export default function Profile() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const user = userInfo?.name;

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <ButtonBase
        sx={(theme) => ({
          p: 0.25,
          bgcolor: open ? 'grey.100' : 'transparent',
          borderRadius: 1,
          '&:hover': { bgcolor: 'secondary.lighter' },
          '&:focus-visible': { outline: `2px solid ${theme.palette.secondary.dark}`, outlineOffset: 2 },
          ...theme.applyStyles('dark', { bgcolor: open ? 'background.default' : 'transparent', '&:hover': { bgcolor: 'secondary.light' } })
        })}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? 'profile-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center', p: 0.5 }}>
          <Avatar alt="profile user" src={avatar1} size="sm" />
          <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
          {user}
          </Typography>
        </Stack>
      </ButtonBase>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper sx={(theme) => ({ boxShadow: theme.customShadows.z1, width: 290, minWidth: 240, maxWidth: { xs: 250, md: 290 } })}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Grid>
                        <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center' }}>
                          <Avatar alt="profile user" src={avatar1} sx={{ width: 32, height: 32 }} />
                          <Stack>
                            <Typography variant="h6">{user}</Typography>
                            {/* <Typography variant="body2" color="text.secondary">
                              UI/UX Designer
                            </Typography> */}
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid>
                        <Tooltip title="Logout">
                          <IconButton
                            size="large"
                            sx={{ color: 'text.primary' }}
                            onClick={() => {
                              logout();          // clear localStorage + context
                              navigate('/login'); // redirect to login page
                            }}
                          >
                            <LogoutOutlined />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </CardContent>


                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
}

TabPanel.propTypes = { children: PropTypes.node, value: PropTypes.number, index: PropTypes.number, other: PropTypes.any };




// import PropTypes from 'prop-types';
// import { useRef, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import {
//   ButtonBase, CardContent, ClickAwayListener, Grid, Paper, Popper,
//   Stack, Tooltip, Typography, Box, Divider, MenuItem
// } from '@mui/material';
// import { useAuth } from '../../../../../sections/auth/AuthContext';
// import Avatar from 'components/@extended/Avatar';
// import MainCard from 'components/MainCard';
// import Transitions from 'components/@extended/Transitions';
// import IconButton from 'components/@extended/IconButton';
// import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
// import avatar1 from 'assets/images/users/admin.png';
// import { useNavigate } from 'react-router';

// export default function Profile() {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const { logout } = useAuth();
//   const anchorRef = useRef(null);
//   const [open, setOpen] = useState(false);

//   const handleToggle = () => setOpen((prevOpen) => !prevOpen);
//   const handleClose = (event) => {
//     if (anchorRef.current && anchorRef.current.contains(event.target)) return;
//     setOpen(false);
//   };

//   // 🧠 Fetch user info from localStorage
//   const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
//   const isAdmin = userInfo?.role === 'Admin' && userInfo?.roleID === "1";

//   return (
//     <Box sx={{ flexShrink: 0, ml: 0.75 }}>
//       <ButtonBase
//         sx={(theme) => ({
//           p: 0.25,
//           bgcolor: open ? 'grey.100' : 'transparent',
//           borderRadius: 1,
//           '&:hover': { bgcolor: 'secondary.lighter' },
//           '&:focus-visible': {
//             outline: `2px solid ${theme.palette.secondary.dark}`,
//             outlineOffset: 2
//           },
//           ...theme.applyStyles('dark', {
//             bgcolor: open ? 'background.default' : 'transparent',
//             '&:hover': { bgcolor: 'secondary.light' }
//           })
//         })}
//         aria-label="open profile"
//         ref={anchorRef}
//         aria-controls={open ? 'profile-grow' : undefined}
//         aria-haspopup="true"
//         onClick={handleToggle}
//       >
//         <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center', p: 0.5 }}>
//           <Avatar alt="profile user" src={avatar1} size="sm" />
//           <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
//             {userInfo?.username || 'Admin'}
//           </Typography>
//         </Stack>
//       </ButtonBase>

//       <Popper
//         placement="bottom-end"
//         open={open}
//         anchorEl={anchorRef.current}
//         transition
//         disablePortal
//         popperOptions={{ modifiers: [{ name: 'offset', options: { offset: [0, 9] } }] }}
//       >
//         {({ TransitionProps }) => (
//           <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
//             <Paper sx={(theme) => ({ boxShadow: theme.customShadows.z1, width: 260 })}>
//               <ClickAwayListener onClickAway={handleClose}>
//                 <MainCard elevation={0} border={false} content={false}>
//                   <CardContent sx={{ px: 2.5, pt: 2 }}>
//                     <Grid container justifyContent="space-between" alignItems="center">
//                       <Grid>
//                         <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center' }}>
//                           <Avatar alt="profile user" src={avatar1} sx={{ width: 32, height: 32 }} />
//                           <Stack>
//                             <Typography variant="h6">{userInfo?.username || 'Admin'}</Typography>
//                           </Stack>
//                         </Stack>
//                       </Grid>
//                       <Grid>
//                         <Tooltip title="Logout">
//                           <IconButton
//                             size="large"
//                             sx={{ color: 'text.primary' }}
//                             onClick={() => {
//                               logout();
//                               navigate('/login');
//                             }}
//                           >
//                             <LogoutOutlined />
//                           </IconButton>
//                         </Tooltip>
//                       </Grid>
//                     </Grid>
//                   </CardContent>

//                   {/* 🔒 Admin-only links */}
//                   {isAdmin && (
//                     <>
//                       <Divider />
//                       <Stack sx={{ px: 1, pb: 1 }}>
//                         <MenuItem onClick={() => { navigate('/company'); setOpen(false); }}>
//                           Company
//                         </MenuItem>
//                         <MenuItem onClick={() => { navigate('/iam'); setOpen(false); }}>
//                           IAM
//                         </MenuItem>
//                       </Stack>
//                     </>
//                   )}
//                 </MainCard>
//               </ClickAwayListener>
//             </Paper>
//           </Transitions>
//         )}
//       </Popper>
//     </Box>
//   );
// }

// Profile.propTypes = { children: PropTypes.node, value: PropTypes.number, index: PropTypes.number, other: PropTypes.any };
